import CrossPlatformImage from './CrossPlatformImage'

export default CrossPlatformImage